import { Modal } from '@/components/Layout';
import React from 'react';
import { useEstablishments } from '../../hooks';
import { Button } from '@/components/Common';
import { useEstablishmentStore } from '@/store/EstablishmentStore/EstablishmentStore';

const EstablishmentSendMailModal = () => {
  const { isSendMailPending, onSendMail } = useEstablishments();
  const { isOpenEstablishmentSendMailModal, closeEstablishmentSendMailModal } =
    useEstablishmentStore();

  return (
    <Modal
      isOpen={isOpenEstablishmentSendMailModal}
      onClose={closeEstablishmentSendMailModal}
      modalStyle="bg-[#2A2A2A] min-w-[23.4375rem]"
      headerStyle="bg-[#2A2A2A]"
    >
      <div className="flex flex-col gap-1">
        <h3 className="text-white text-xl font-bold text-center mb-2">
          Renvoyer le mail de confirmation
        </h3>
        <p className="text-center text-gray-400 mx-auto my-0">
          Validez l'envoie ?
        </p>
        <div className="flex justify-between items-center gap-6 mt-4">
          <Button
            onClick={closeEstablishmentSendMailModal}
            title="Non"
            className="!bg-completed hover:!outline-completed hover:!text-completed
                hover:!bg-hoverColor text-white !px-16"
          />
          <Button
            className="!px-16"
            title={isSendMailPending ? 'Envoi en cours...' : 'Oui'}
            onClick={onSendMail}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EstablishmentSendMailModal;
